/** 列表标签与表单 tooltip：去广告随 VIP 到期，退款会一刀切关闭该用户 API 去广告。 */
export const HIDE_AD_TOOLTIP =
  '开启后用户购买该套餐会同步开通用户级去广告，到期与本笔 VIP 一致。退款成功会关闭该用户全部 API 去广告。';

export const HIDE_AD_EXTRA = '退款回收是用户级一刀切，不单独保留其他未退订单的去广告。';

/** 创建/更新必须显式带 0 或 1；缺省、非法值一律按关闭。 */
export function toHideAdFlag(value: unknown): 0 | 1 {
  return value === 1 || value === true || value === '1' ? 1 : 0;
}
